import { beginAppLogout } from './logoutState';
import { Utils } from 'core/utils';

/**
 * Clears backend session, drops auth-related React Query caches, then Auth0 logout or hard navigation.
 * @param {import('react-query').QueryClient | undefined | null} queryClient
 * @param {{ isAuth0Authenticated: boolean; auth0Logout?: (opts?: object) => void | Promise<void> }} options
 */
export function performAppLogout(queryClient, { isAuth0Authenticated, auth0Logout }) {
  beginAppLogout();

  if (queryClient) {
    queryClient.cancelQueries({ queryKey: ['auth0ServerLogin'], exact: false });
    queryClient.removeQueries({ queryKey: ['auth0ServerLogin'], exact: false });
    queryClient.removeQueries({ queryKey: ['profile'], exact: false });
  }

  Utils.removeUserSession();

  if (isAuth0Authenticated && typeof auth0Logout === 'function') {
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
    return;
  }

  window.location.assign(`${window.location.origin}/`);
}
